<template>
  <v-list
    three-lines
    :style="divider ? `border-bottom: 1px solid rgba(0,0,0,.12)` : ''"
    class="pa-0"
  >
    <template v-if="maxCartQuantity === 1">
      <v-radio
        color="primary"
        class="radio-reverse"
        :value="`${type.codigo_produto}-${type.codigo_tipo}`"
      >
        <template slot="label" style="flex: 1">
          <v-layout
            row
            class="product-type-info"
            :key="`${type.codigo_produto}-${type.codigo_tipo}`"
          >
            <v-flex xs9 sm10 lg10>
              <h3 class="product-title">
                {{ type.nome }} - {{ type.nome_tipo }}
              </h3>
              <h4 class="product-price" v-html="productPriceDetails(type)"></h4>
            </v-flex>
          </v-layout>
        </template>
      </v-radio>
    </template>
    <template v-else>
      <v-layout
        row
        class="product-type-info"
        :key="`${type.codigo_produto}-${type.codigo_tipo}`"
      >
        <v-flex xs9 sm10 lg10>
          <h3 class="product-title">{{ type.nome }} - {{ type.nome_tipo }}</h3>
          <h4
            class="product-price"
            v-if="!type.encerrado && !type.esgotado"
            v-html="productPriceDetails(type)"
          ></h4>
        </v-flex>
        <v-flex xs3 sm2 lg2>
          <v-layout
            align-center
            justify-center
            row
            fill-height
            v-if="type.esgotado"
          >
            <v-chip outline color="#838D9B">Esgotado</v-chip>
          </v-layout>
          <v-layout
            align-center
            justify-center
            row
            fill-height
            v-else-if="type.encerrado"
          >
            <v-chip outline color="#838D9B">Encerrado</v-chip>
          </v-layout>
          <v-layout align-center justify-space-between row fill-height v-else>
            <div>
              <v-btn
                class="add-remove-button mr-2"
                outline
                small
                fab
                :style="
                  $route.name === 'totem'
                    ? 'height: 37px !important; width: 37px !important'
                    : ''
                "
                color="secondary"
                :disabled="type.quantidade === 0"
                @click="remove(type)"
              >
                <v-icon class="add-remove-button__icon">remove</v-icon>
              </v-btn>
            </div>
            <div class="text-xs-center">
              <span class="product-quantity secondary--text">{{
                type.quantidade
              }}</span>
            </div>
            <div>
              <v-btn
                class="add-remove-button ml-2"
                outline
                small
                fab
                :style="
                  $route.name === 'totem'
                    ? 'height: 37px !important; width: 37px !important'
                    : ''
                "
                color="secondary"
                :disabled="
                  type.quantidade >= type.quantidade_maxima ||
                    productsQuantity >= maxProdutosCpf ||
                    hasReachedMax
                "
                @click="add(type)"
              >
                <v-icon class="add-remove-button__icon">add</v-icon>
              </v-btn>
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </template>
  </v-list>
</template>

<script>
export default {
  props: ['type', 'selectOnLoad', 'divider'],
  data() {
    return {
      selection: false,
    };
  },
  mounted() {
    if (this.selectOnLoad) {
      this.add(this.type);
    }
  },
  computed: {
    maxCartQuantity() {
      return this.$store.getters.maxProductsCart;
    },
    eventID() {
      return this.$store.getters.eventID;
    },
    cartProducts() {
      return this.$store.getters.cartProducts;
    },
    eventDetails() {
      return this.$store.getters.eventDetails;
    },
    eventName() {
      return this.$store.getters.eventName;
    },
    cartProducts() {
      return this.$store.getters.cartProducts;
    },
    maxProdutosCpf() {
      return this.$store.getters.maxProdutosCpf;
    },
    productsQuantity() {
      let total = 0;
      if (this.hasProductsCart) {
        this.cartProducts.forEach(p => {
          p.forEach(v => {
            total += v.quantidade;
          });
        });
      }
      return total;
    },
    hasProductsCart() {
      let total = 0;
      this.cartProducts.forEach(p => {
        total += p.length;
      });
      return total;
    },
    hasReachedMax() {
      if (this.productsQuantity >= this.maxCartQuantity) return true;
      else return false;
    },
  },
  methods: {
    add(product) {
      product.haveSeat = false;
      if (product.quantidade === 0 && product.quantidade_minima > 1) {
        for (var i = 0; i < product.quantidade_minima; i++) {
          this.$store.dispatch('addCartProduct', product);
          this.$store.dispatch('incrementProductsQuantity', product);
        }
      } else {
        this.$store.dispatch('addCartProduct', product);
        this.$store.dispatch('incrementProductsQuantity', product);
      }
    },
    remove(product) {
      if (product.quantidade <= 0) product.quantidade = 0;
      if (product.quantidade > 0) {
        product.haveSeat = false;
        if (product.quantidade === product.quantidade_minima) {
          for (var i = 0; i < product.quantidade_minima; i++) {
            this.$store.dispatch('removeCartProduct', product);
            this.$store.dispatch('decrementProductsQuantity', product);
          }
        } else {
          this.$store.dispatch('removeCartProduct', product);
          this.$store.dispatch('decrementProductsQuantity', product);
        }
      }
    },
    productPriceDetails(product) {
      const value = this.$options.filters.currency(product.valor * 100);
      const tax = product.valor_conveniencia
        ? ` + ${this.$options.filters.currency(
            product.valor_conveniencia * 100
          )} taxa`
        : '';
      const lote = ` (Lote ${product.lote})`;
      if (product.cupom === 1)
        return `<span style="font-size: 16px; color: #00A65A">${value}</span>${tax}${
          this.eventDetails &&
          this.eventDetails.exibir_lote &&
          product.tipo_produto !== 'M'
            ? lote
            : ''
        }`;
      else
        return `<span style="font-size: 16px; color: #1976d2">${value}</span>${tax}${
          this.eventDetails &&
          this.eventDetails.exibir_lote &&
          product.tipo_produto !== 'M'
            ? lote
            : ''
        }`;
    },
  },
  filters: {
    limit: value => {
      return value.substring(0, 14);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "~@/assets/product/productTypes.styl"
</style>

<style scoped>
.radio-reverse {
  flex-flow: row-reverse;
  justify-content: space-between;
}
</style>
